import React from 'react'
import { Switch, Route } from 'react-router-dom'
import axios from 'axios'
import getHeader from '../auth/csrf_cookie'
import NavBar from '../core/navbar/navbar'
import Footer from '../core/footer/footer'
import './news_route.css'

//imports
const Login           = React.lazy(() => import('../pages/news/public/login/login'))

//Public Routes
const NewsView        = React.lazy(() => import('../pages/news/public/newsview/newsview'))
const PaginatePublic  = React.lazy(() => import('../pages/news/public/paginatenews/paginatenews'))
//Not Found
const NotFound        = React.lazy(() => import('../core/notfound/notfound'))
//route definitions
export default class NewsRoute extends React.Component{
  constructor(props){
    super(props)
    this.state  = {
      isLoggedIn  : null
    }
  }
  isLoggedIn = () => {
    //check if a user is logged in
    return new Promise((res, rej) => {
      axios.get(`${process.env.REACT_APP_API_ENDPOINT}/api/user/news/check`, getHeader())
      .then((resp) => {
        this.setState({
          isLoggedIn : true
        })
        res(true)
      })
      .catch((rej) => {
        this.setState({
          isLoggedIn : false
        })
        res(false)
      })
    })
  }
  render(){
    return(
      <React.Fragment>
        <NavBar />
        <main className = "news-content">
          <Switch>
            {/* Here goes the public routes*/}
            <Route exact path = '/news' component = {PaginatePublic}/>
            <Route exact path = '/news/:slug' component = {NewsView}/>
            <Route exact path = '/news/public/login' component = {Login}/>
            <NotFound />
          </Switch>
        </main>
        <Footer />
      </React.Fragment>
    )
  }
}
